import { render, staticRenderFns } from "./AudioWave.vue?vue&type=template&id=c9fbf388&"
import script from "./AudioWave.vue?vue&type=script&lang=js&"
export * from "./AudioWave.vue?vue&type=script&lang=js&"
import style0 from "./AudioWave.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports